(() => {
  if (customElements.get("rush-bestsellers")) return;

  class RushBestsellers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rushInitialized === "true") return;

      this.dataset.rushInitialized = "true";
      this.scrollContainer = this.querySelector(".ai-bestsellers-scroll-container");
      this.previousButton = this.querySelector("[data-bestsellers-prev]");
      this.nextButton = this.querySelector("[data-bestsellers-next]");

      if (!this.scrollContainer) return;

      this.handlePrevious = () => this.scrollByCards(-1);
      this.handleNext = () => this.scrollByCards(1);
      this.handleScroll = () => this.updateControls();
      this.handleKeydown = (event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        this.scrollByCards(event.key === "ArrowLeft" ? -1 : 1);
      };

      this.previousButton?.addEventListener("click", this.handlePrevious);
      this.nextButton?.addEventListener("click", this.handleNext);
      this.scrollContainer.addEventListener("scroll", this.handleScroll, { passive: true });
      this.scrollContainer.addEventListener("keydown", this.handleKeydown);
      this.resizeObserver = new ResizeObserver(this.handleScroll);
      this.resizeObserver.observe(this.scrollContainer);
      this.updateControls();
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener("click", this.handlePrevious);
      this.nextButton?.removeEventListener("click", this.handleNext);
      this.scrollContainer?.removeEventListener("scroll", this.handleScroll);
      this.scrollContainer?.removeEventListener("keydown", this.handleKeydown);
      this.resizeObserver?.disconnect();
    }

    scrollByCards(direction) {
      const firstCard = this.querySelector(".ai-bestsellers-card");
      const cardWidth = firstCard?.getBoundingClientRect().width || 280;

      this.scrollContainer.scrollBy({
        left: direction * (cardWidth + 18) * 2,
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
      });
    }

    updateControls() {
      const maximumScroll = Math.max(0, this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth);
      const atStart = this.scrollContainer.scrollLeft <= 2;
      const atEnd = this.scrollContainer.scrollLeft >= maximumScroll - 2;

      if (this.previousButton) this.previousButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;
    }
  }

  customElements.define("rush-bestsellers", RushBestsellers);
})();
